import { api } from "./client";
import type {
  Extraction,
  ExtractionBulkUpdateRequest,
  ExtractionBulkUpdateResponse,
  ExtractionPatch,
  ExtractionStatus,
  ExtractionSummaryRow,
} from "../types";

export interface ExtractionFilters {
  label?: string;
  status?: ExtractionStatus;
}

export interface StartExtractionRequest {
  labels?: string[];
}

export async function startExtraction(
  projectId: string,
  body: StartExtractionRequest = {},
): Promise<{ job_id: string; reused?: boolean }> {
  const { data } = await api.post<{ job_id: string; reused?: boolean }>(
    `/projects/${projectId}/extract`,
    body,
  );
  return data;
}

export async function getExtractions(
  projectId: string,
  filters?: ExtractionFilters,
): Promise<Extraction[]> {
  const { data } = await api.get<Extraction[]>(`/projects/${projectId}/extractions`, {
    params: filters,
  });
  return data;
}

export async function getExtractionsSummary(
  projectId: string,
): Promise<ExtractionSummaryRow[]> {
  const { data } = await api.get<ExtractionSummaryRow[]>(
    `/projects/${projectId}/extractions/summary`,
  );
  return data;
}

export async function patchExtraction(
  extractionId: string,
  body: ExtractionPatch,
): Promise<Extraction> {
  const { data } = await api.patch<Extraction>(`/extractions/${extractionId}`, body);
  return data;
}

export async function bulkUpdateExtractions(
  projectId: string,
  body: ExtractionBulkUpdateRequest,
): Promise<ExtractionBulkUpdateResponse> {
  const { data } = await api.post<ExtractionBulkUpdateResponse>(
    `/projects/${projectId}/extractions/bulk-update`,
    body,
  );
  return data;
}
